import { useMutation, useQueryClient } from 'react-query';

import {
  AgencyQuickReplyDto,
  UpdateAgencyQuickReplyDto,
} from '@bandido/shared/dtos';
import { client } from '@frontend/features/common/services';
import { QueryKeys } from '@frontend/features/common/types';

type UpdateQuickReplyPayload = {
  quickReplyId: number;
  data: UpdateAgencyQuickReplyDto;
};

export const useUpdateQuickReply = (agencyId?: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ quickReplyId, data: payload }: UpdateQuickReplyPayload): Promise<AgencyQuickReplyDto> => {
      if (!agencyId) {
        return Promise.reject(new Error('Agency ID is required'));
      }

      const { data } = await client.patch(
        `/whatsapp/quick-replies/${agencyId}/${quickReplyId}`,
        payload,
      );
      return data;
    },
    {
      onSuccess: () => {
        if (!agencyId) return;
        queryClient.invalidateQueries([QueryKeys.getWhatsappQuickReplies, agencyId]);
      },
    },
  );
};
